import Review from "./Review.component";

export default Review;
